/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiClientFromJSON, ApiClientToJSON, } from './ApiClient';
export function ApiOAuthTokenFromJSON(json) {
    return ApiOAuthTokenFromJSONTyped(json, false);
}
export function ApiOAuthTokenFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'apiToken': !exists(json, 'apiToken') ? undefined : json['apiToken'],
        'client': !exists(json, 'client') ? undefined : ApiClientFromJSON(json['client']),
        'clientId': !exists(json, 'clientId') ? undefined : json['clientId'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'tokenExpires': !exists(json, 'tokenExpires') ? undefined : json['tokenExpires'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
    };
}
export function ApiOAuthTokenToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'apiToken': value.apiToken,
        'client': ApiClientToJSON(value.client),
        'clientId': value.clientId,
        'id': value.id,
        'tokenExpires': value.tokenExpires,
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
    };
}
